import {
  INITIALIZE,
  CLOSE as aMCloseActionType,
} from 'ha/modules/ActivationModal/actions';
import { CLOSE } from 'ha/modules/ModalsLogic/actions';
import handleOpen from './handleOpen';
import handleClose from './handleClose';

const activationModalMiddleware = store => next => action => {
  if (
    action.type === INITIALIZE ||
    (action.type === CLOSE &&
      action.payload &&
      action.payload.modal === 'activation-modal')
  ) {
    handleOpen({
      store,
      action,
    });
  } else if (action.type === aMCloseActionType) {
    handleClose({ store });
  }

  return next(action);
};

export default activationModalMiddleware;
